type AtenaCard = {
  id: string
  title: string
  previewJumpId: string
}

const atenaCards: AtenaCard[] = [
  {
    id: 'userprofile',
    title: '差出人情報',
    previewJumpId: 'preview-page-01'
  },
  {
    id: 'size',
    title: 'サイズ選択',
    previewJumpId: 'preview-page-01'
  },
  {
    id: 'atena-info',
    title: '宛名情報',
    previewJumpId: 'preview-page-01'
  },
  {
    id: 'confirm',
    title: '確認',
    previewJumpId: 'confirm-preview'
  },
  {
    id: 'output',
    title: '完了',
    previewJumpId: 'preview-page-01'
  }
]

export default atenaCards
